export const FULL_NORTH_AMERICAN_COUNTRY_NAMES = ['United States', 'Canada'];

export const getIsNorthAmericanCountryName = (countryName?: string) =>
  FULL_NORTH_AMERICAN_COUNTRY_NAMES.includes(countryName ?? '');
